import React from 'react'
import * as S from '../styled'
import { TutorialItem } from '../types'
import { navigate } from '@app/navigation'

interface TutorialItemCardProps {
  item: TutorialItem
  onOpen: (item: TutorialItem) => void
}

const TutorialItemCard = React.memo<TutorialItemCardProps>(
  ({ item, onOpen }) => {
    return (
      <S.StyledTutorialItemCard onClick={() => onOpen(item)}>
        <S.TutorialHeaderContainer tabIndex={0}>
          <S.TutorialHeaderMain>
            <S.TutorialTitle>{item.title}</S.TutorialTitle>
          </S.TutorialHeaderMain>
        </S.TutorialHeaderContainer>

        <S.TutorialDescription>{item.description}</S.TutorialDescription>
      </S.StyledTutorialItemCard>
    )
  }
)

export default TutorialItemCard
